<template>
  <div class="checkbox">
      <label class="checkbox__wrap">
          <span class="checkbox__input-wrap">
              <input type="checkbox" v-model="localValue"  class="checkbox__input">
              <span class="checkbox__icon"></span>
          </span>
          <p class="checkbox__text-wrap">
              <span class="checkbox__label-text" v-bind:class="labelClass">{{label}}</span>
             <slot></slot>
          </p>
      </label>
  </div>
</template>

<script>
    import {STATUSES} from "../statuses";
    import each from 'lodash/each'

    export default {
        name: 'cCheckbox',
        model: {
            prop: 'checked',
            event: 'change'
        },
        props: {
            checked: {
                type: Boolean
            },
            label: {
                default: 'Заголовок'
            },
            labelClass: {
                default: ''
            }
        },
        data() {
            return {
                localValue: this.checked,
            }
        },
        watch: {
            localValue: function (newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.$emit('change', newVal);
                }
            },
            checked: function (newVal, oldVal) {
                this.localValue = this.checked;
            }
        },
        methods: {
            isItemSelect: function (value) {
                return {'c-radio-group__item--selected': this.localValue === value};
            },
        },
        computed: {

        },
        mounted(){
        }

    }
</script>

<style lang="scss">
    @import "~@/assets/scss/variable";
    .checkbox{
        &__wrap{
            display: flex;
            justify-content: space-between;
            &:hover{
                cursor: pointer;
                .checkbox__input:not(:checked) ~ .checkbox__icon{
                    border: 1px solid $purple-site;
                }
            }
        }
        &__input-wrap{}
        &__input{
            display: none;
        }
        &__input:checked ~ .checkbox__icon{
            &:after{
                content: '';
                display: block;
                position: absolute;
                width: 24px;
                height: 24px;
                background: url('~@/assets/svg/components/check_purp.svg') no-repeat center center;
                background-size: 20px 20px;
                top: -6px;
                left: 0;
            }
        }
        &__input:not(:checked) ~ .checkbox__icon{

        }
        &__icon{
            width: 20px;
            height: 20px;
            display: block;
            border: 1px solid #E8E8E8;
            border-radius: 5px;
            position: relative;
        }
        &__text-wrap{
            text-align: left;
            max-width: 280px;
            width: 100%;
            padding-right: 10px;
            margin-left: 20px;
        }
        &__label-text{
            display: block;
            font-size: 14px;
            color: #9B9B9B;
        }
        &__label-text--purple{
            font-family: $RobotoMedium;
            font-size: 18px;
            color: $purple-site;
        }
    }
</style>